import AcceptProposal from './AcceptProposal';
export default AcceptProposal;